<template>
  <div class="sf-bg-background sf-c sf-pv-xl sf-ph-s sf-ta-c">
    <div class="layout__wrapper sf-pv-l sf-ph-s">
      <div v-if="$slots.icon" :style="{ background: iconBg }" class="layout__icon">
        <slot name="icon"/>
      </div>
      <div :style="{ maxWidth }" class="layout__content">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iconBg: { type: String, default: '#fff' },
    maxWidth: { type: String, default: '600px' },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  &__wrapper {
    position: relative;
    width: 100%;
    max-width: 960px;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    background: #ffffff;
    border-radius: 8px;
  }

  &__icon {
    @extend %centered;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    border: 3px solid white;
    border-radius: 50%;
    box-shadow: -4px 6px 20px rgba(0, 0, 0, 0.1);

    @include mobile {
      @include square(80px);
    }

    @include tablet {
      @include square(100px);
    }

    & > * {
      @include mobile {
        @include square(28px);
      }

      @include tablet {
        @include square(38px);
      }
    }
  }

  &__content {
    width: 100%;
  }
}
</style>
